import React, { useEffect, useState } from "react";
import HeaderLogado from "../HeaderLogado";
import "./index.css";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from "swiper";
import ApiServices from "../../services/apiServices";
import storage from "../../services/storage";
import { useNavigate } from "react-router";
import { Divider, Grid } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CachedIcon from "@mui/icons-material/Cached";
import { margin } from "@mui/system";
import { useLoad } from "../../context";
import loading from "../../assets/images/svgs/loading.svg";
import Mask from "../../services/mask";
import LiAceito from "../../Components/LiAceito";
import CardProduto from "../../Components/CardProduto";
import { filterProductsByUserCategory } from "../../utils/categoryFilter";

export default function HomeLogado() {
  const [bannerImg, setBannerImg] = useState([]);
  const navigate = useNavigate();
  const [user] = useState(storage.get("USUARIO")?.loginResponse);
  const [saldo, setSaldo] = useState("");
  const [mostrarSaldo, setMostrarSaldo] = useState(false);
  const [loadPontos, setLoadPontos] = useState(false);
  const { load, setLoad } = useLoad();
  const [listaProdutos, setListaProdutos] = useState([]);
  // document.cookie.set('myCat', 'Pacman')

  if (storage.get("TOKEN") == null) {
    navigate("/deslogado");
    storage.del("INFOPOPUP");
  }

  // comentário qualquer

  useEffect(() => {
    fnCarregarBannerRotativo();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  function fnCarregarBannerRotativo() {
    ApiServices.apiGetTokenBearer("banner?ativo=true&pageSize=9999")
      .then((res) => {
        res.data.items.sort(function (a, b) {
          return a.ordem - b.ordem; // Ordena do maior para o menor
        });
        setBannerImg(res.data.items);
      })
      .catch((err) => console.error("err", err));
  }

  async function fnCarregarSaldo() {
    var init = {
      token: user.token,
      mes: "",
      ano: "",
    };
    try {
      setLoad(true);
      setLoadPontos(true);
      let response = await ApiServices.apiPost("vitrineorder/saldo", init);

      setSaldo(Mask.numeroPontos(response.data.balance.toString()));
      setLoadPontos(false);
      // setSaldo(Mask.numeroPontos((2000).toString()));
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  function fnMostrarSaldo() {
    if (mostrarSaldo) {
      setMostrarSaldo(false);
    } else {
      setMostrarSaldo(true);
      fnCarregarSaldo();
    }
  }

  async function fnListaProdutos() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet(
        `produto/de-produto-destaque`
        // `produto/de-produto?disponivel=${"filtro.disponivel"}&descricao=${filtro.descricao}&categoriaId=${filtro.categoriaId}&pontos=${filtro.pontos}`
      );
      // Filter products based on user's category
      const filteredProducts = filterProductsByUserCategory(response.data);
      setListaProdutos(filteredProducts);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  useEffect(() => {
    fnListaProdutos();
    if (storage.get("IR-CAMPANHA") === true) {
      navigate("/catalogo/vitrine-leo/campanha");
    }
  }, []);
  return (
    <>
      {bannerImg && bannerImg.length > 0 && bannerImg.some((e) => e.ativo) && (
        <>
          <div className="container">
            <Swiper
              pagination={{
                clickable: true,
              }}
              loop={false}
              autoplay={
                bannerImg.filter((e) => e.ativo).length > 1
                  ? {
                      delay: 5000,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                    }
                  : false
              }
              modules={[Autoplay, Pagination, Navigation]}
              className="mySwiper desktop"
            >
              {bannerImg.map(
                (e, i) =>
                  e.ativo && (
                    <SwiperSlide key={i}>
                      <a
                        href={e.link}
                        target="_self"
                        className="pointer banner-link"
                        style={{
                          borderRadius: 30,
                          overflow: "hidden",
                          margin: "30px 0",
                          width: "100%",
                          display: "block",
                        }}
                      >
                        <img
                          src={e.imagemSiteSource}
                          alt=""
                          style={{
                            width: "100%",
                            height: "auto",
                            display: "block",
                          }}
                        />
                      </a>
                    </SwiperSlide>
                  )
              )}
            </Swiper>
          </div>

          <Swiper
            pagination={{
              clickable: true,
            }}
            loop={false}
            autoplay={
              bannerImg.filter((e) => e.ativo).length > 1
                ? {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }
                : false
            }
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper mobile"
          >
            {bannerImg.map(
              (e, i) =>
                e.ativo && (
                  <SwiperSlide key={i}>
                    <a
                      href={e.link}
                      target="_self"
                      className="pointer banner-link"
                      style={{
                        overflow: "hidden",
                        margin: "60px 0 30px 0",
                        width: "100%",
                        display: "block",
                      }}
                    >
                      <img
                        src={e.imagemMobileSource}
                        alt=""
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block",
                        }}
                      />
                    </a>
                  </SwiperSlide>
                )
            )}
          </Swiper>
        </>
      )}

      {listaProdutos && listaProdutos.length > 0 && (
        <div className="container d-flex justify-content-center my-5">
          <Swiper
            slidesPerView={5}
            spaceBetween={15}
            loop={listaProdutos.length > 5}
            autoplay={
              listaProdutos.length > 5
                ? {
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }
                : false
            }
            modules={[Autoplay]}
            className="mySwiper"
            style={{ width: "100%" }}
            breakpoints={{
              // adjust as you wish these breakpoints for responsive design
              0: { slidesPerView: 1 },
              320: { slidesPerView: 2 },
              550: { slidesPerView: 3 },
              736: { slidesPerView: 3 },
              1000: { slidesPerView: 4 },
              1200: { slidesPerView: 5 },
            }}
          >
            {listaProdutos.map((e, i) => (
              <SwiperSlide key={i}>
                <CardProduto key={i} product={e} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
      <LiAceito />
    </>
  );
}
